export default function getCompleteUiUrl(config: any, route: string) {
    return config.uiRoute + route
}